module.exports = __webpack_public_path__ + "img/img_banner_sort03.69a8b4ea.svg";